module.exports = __webpack_public_path__ + "img/onboarding.7bca38e1.jpg";